import * as React from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';

import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';

import { ReactNode } from 'react';
import { Badge, Button } from '@material-ui/core';

type ConfigItem = { label: string; value: string | undefined | null };

interface Props {
  config: Array<ConfigItem>;
  title: string;
  children?: ReactNode;
}

const Details: React.FC<Props> = ({ config, title, children }) => {
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const renderConfigItem = ({ label, value }: ConfigItem): ReactNode => (
    <div>
      <div className="text-sm text-gray-500">{label}</div>
      <div>{value || '-'}</div>
    </div>
  );

  return (
    <Card style={{ border: '1px solid #ccc' }}>
      <CardHeader titleTypographyProps={{ variant: 'h6', className: 'font-bold ' }} title={title} />
      <CardContent>
        <div className="grid grid-cols-2 gap-4">{config.map(renderConfigItem)}</div>
      </CardContent>
      <CardActions>
        <Button variant="outlined" color="primary" onClick={handleExpandClick}>
          {expanded ? 'Hide payments' : 'Show payments'}
        </Button>
      </CardActions>
      {children && (
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <CardContent>{children}</CardContent>
        </Collapse>
      )}
    </Card>
  );
};

export default Details;
